import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PageHeaderComponent, IconButtonComponent } from '@libs/common/components';
import { SrmCreateFormComponent } from '../srm-create-form';
import { SrmNavigationService } from '../srm-navigation.service';

@Component({
  selector: 'ui-srm-create',
  templateUrl: './srm-create.component.html',
  styleUrls: ['./srm-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PageHeaderComponent,
    SrmCreateFormComponent,
    IconButtonComponent
],
})
export class SrmCreateComponent {
  private readonly router: Router = inject(Router);
  private readonly navigation: SrmNavigationService = inject(SrmNavigationService);

  protected navigateToTicketOverview(): void {
    void this.router.navigateByUrl(this.navigation.overviewPath());
  }
}
